import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Amplify, { Auth } from 'aws-amplify';
import config from './aws-config';
import configureStore from './store/configureStore';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
const store = configureStore;

const amplifyConfig = {
  ...config,
  Auth: {
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },
};

// 仅开发环境调试：把 Auth / 配置挂到全局，方便在 DevTools 里调用
if (process.env.NODE_ENV !== 'production') {
  window.Auth = Auth;
  window.awsCfg = amplifyConfig;
}

Amplify.configure(amplifyConfig);
ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </Provider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
